import React, { useState } from "react";
import { faqs } from "../data/siteContent";

function FQA() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section id="faq-2" className="faq-2 section light-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>Frequently Asked Questions</h2>
        <p>
          A quick overview of how we work, what we build, and how to start a
          conversation with the team.
        </p>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="faq-container">
              {faqs.map((item, index) => (
                <div
                  className={`faq-item ${activeIndex === index ? "faq-active" : ""}`}
                  key={item.question}
                >
                  <button
                    type="button"
                    className="faq-trigger"
                    onClick={() => handleToggle(index)}
                  >
                    <i className="faq-icon bi bi-question-circle"></i>
                    <h3>{item.question}</h3>
                    <i className="faq-toggle bi bi-chevron-right"></i>
                  </button>
                  <div className="faq-content" aria-hidden={activeIndex !== index}>
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FQA;
